require("flatpickr/dist/themes/airbnb.css")

import "./controllers"
import flatpickr from "flatpickr"
import 'flowbite'
import "@fortawesome/fontawesome-free/js/all"
import "@hotwired/turbo-rails"
